import { Button } from "shared/ui/button";
import { getLocalIsoString } from "shared/lib/hooks";
import Checkbox from "../assets/Checkbox.svg";
import CheckboxActive from "../assets/CheckboxActive.svg";
import PrivacyPolicy from "../assets/politika_obrabotki_personalnykh_dannykh.pdf";
import SOPD from "../assets/soglasie_na_obrabotku_personalnykh_dannykh.pdf";
import styles from "./SopdAgreement.module.scss";

export const SopdAgreement = ({ checked, onChange }) => {
  const handleClick = (e) => {
    e.preventDefault();

    const next = !checked;
    const nextCheckedAt = next ? getLocalIsoString() : "";

    onChange?.({
      checked: next,
      checkedAt: nextCheckedAt,
    });
  };

  return (
    <div className={styles.checkboxWrapper}>
      <div className={styles.checkboxWrapper__btnBlock}>
        <div className={styles.checkboxWrapper__btn}>
          <Button
            variant="ghost"
            size="small"
            onClick={handleClick}
            leftIcon={
              <img
                src={checked ? CheckboxActive : Checkbox}
                alt="checkbox"
                height={checked ? 36 : 30}
                width={checked ? 36 : 30}
              />
            }
          />
        </div>
      </div>
      <p className={styles.checkboxWrapper__text}>
        Я ознакомился с{" "}
        <a
          className={styles.checkboxWrapper__link}
          href={PrivacyPolicy}
          target="_blank"
          rel="noopener"
        >
          политикой конфиденциальности
        </a>{" "}
        и даю{" "}
        <a
          className={styles.checkboxWrapper__link}
          href={SOPD}
          target="_blank"
          rel="noopener"
        >
          согласие
        </a>{" "}
        на обработку персональных данных
      </p>
    </div>
  );
};
